import { graphql } from 'app/generated/gql'

/** A call's transcript as SRT text; null when the call has none. */
export const CALL_TRANSCRIPTION_QUERY = graphql(`
  query CallTranscription($id: ID!) {
    callTranscription(id: $id)
  }
`)
